import { render } from "./InclusionPackCard.vue?vue&type=template&id=b1ec870a&scoped=true&ts=true&lang=pug"
import script from "./InclusionPackCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./InclusionPackCard.vue?vue&type=script&lang=ts&setup=true"

import "./InclusionPackCard.vue?vue&type=style&index=0&id=b1ec870a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ec870a"]])

export default __exports__